import GridModel from './gridmodel';
const formatDate = require('../utils/formatdate');

const MakerModel = GridModel.extend({
  idAttribute: 'makerId',
  initialize() {
    GridModel.prototype.initialize.call(this);
  }
});

export default MakerModel;
